import React from 'react';
import {
  Box, FormControl,
  IconButton, InputLabel, MenuItem, Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import DragHandleIcon from '@mui/icons-material/DragHandle';
import './IncomeStatement.css';
import TopToolbar from '../../global/subcomponents/topToolbar/TopToolbar';
import { INCOME_STATEMENT, INCOME_STATEMENT_PAGES } from './constants';
import RefreshIcon from '@material-ui/icons/Refresh';
import EditIcon from '@material-ui/icons/Edit';
import MenuIcon from '@material-ui/icons/Menu';
import Tooltip from '@material-ui/core/Tooltip';
import SettingsIcon from '@material-ui/icons/Settings';
import { HourglassEmptyTwoTone } from '@material-ui/icons';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

class IncomeStatementTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sections: this.props.sections,
      hideFilterBox: false,
    };
  }


  componentDidUpdate(prevProps) {
    // Check if sections prop has changed
    if (prevProps.sections !== this.props.sections) {
      this.setState({ sections: this.props.sections });
    }
  }


  handleExport = () => {
    const { sections } = this.props;
    if (!sections || sections.length === 0) {
      return;
    }

    // Generate CSV content
    const headers = 'name,amount';

    const excludeDebitNames = [
      'Operating Income',
      'Cost of Sales',
      'Operating Expenses',
      'Other Income',
      'Taxes',
      ''
    ];

    const rows = sections.map(row => {
      let name = row.name ?? ''
      if (name.includes(',')) {
        name = `"${name}"`
      }
      const amount = excludeDebitNames.includes(name) ? '' : row.debit ?? '';
      return `${name},${amount}`;
    });

    const csvContent = [headers, ...rows].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `Income Statement_${this.props.selectedYear}_${this.props.selectedCurrency}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };



  formatBalance = (balance) => {
    return parseFloat(balance)
      .toFixed(2)
      .toString()
      .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
  };


  getContextualMenuItems = () => {
    const { fetchIncomeStatement } =
      this.props;

    // Check if the selected currency is "Consolidated CAD"
    if (this.props.selectedCurrency === 'Consolidated CAD') {

      const menuItems = [
        {
          title: 'Download as CSV',
          icon: <FileDownloadIcon />,
          onClick: () => {
            this.handleExport();
          }
        }
      ];

      if (this.props.loadingData) {
        menuItems.push({
          icon: <HourglassEmptyTwoTone />,
          handler: () => null,
          disabled: true,
          title: "Loading data..."
        });
      }

      return menuItems;
    }

    return [

      {
        title: 'Settings',
        icon: <SettingsIcon />,
        onClick: () => {
          this.props.setCurrentPage(INCOME_STATEMENT_PAGES.SETTINGS)
        }
      },
      {
        title: 'Refresh',
        icon: <RefreshIcon />,
        onClick: () => {
          fetchIncomeStatement({
            year: this.props.selectedYear,
            currency: this.props.selectedCurrency,
          });
        },
      },
      {
        title: 'Download as CSV',
        icon: <FileDownloadIcon />,
        onClick: () => {
          this.handleExport()
        }
      },
      this.props.loadingData &&
      {
        icon: <HourglassEmptyTwoTone />,
        handler: () => null,
        disabled: true,
        title: "Loading data..."
      }

    ];
  };

  render() {
    return (
      <React.Fragment>
        <TopToolbar
          pageName={`${INCOME_STATEMENT} (${this.props.selectedYear} - ${this.props.selectedCurrency})`}
          menuItems={this.getContextualMenuItems()}
        />

        <Box
          className="box-income-statement"
          style={{
            visibility: this.state.hideFilterBox ? 'hidden' : 'visible',
          }}
        >
          <FormControl variant="outlined" className="form-control-ledger">
            <InputLabel id="year-label">Year</InputLabel>
            <Select
              className="select-year-ledger"
              labelId="year-label"
              value={this.props.selectedYear}
              onChange={this.props.handleYearChange}
              label="Year"
            >
              {this.props.years.map((year) => (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl variant="outlined" className="form-control">
            <InputLabel id="currency-label">Currency</InputLabel>
            <Select
              className="select-currency-ledger"
              labelId="currency-label"
              value={this.props.selectedCurrency}
              onChange={this.props.handleCurrencyChange}
              label="Currency"
            >
              {this.props.currency.map((currency) => (
                <MenuItem key={currency} value={currency}>
                  {currency}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        <TableContainer className="MuiTable-root-trail">
          <Table>
            <TableHead className="MuiTableHead-root-trail" style={{ visibility: 'hidden',border:'none' }}>
              <TableRow>
                <TableCell
                  className="MuiTableCell-root-trail"
                  style={{ textAlign: 'left', width: '60px' }}
                ></TableCell>
                <TableCell
                  className="MuiTableCell-root-trail"
                  style={{ textAlign: 'left' }}
                >
                  Name
                </TableCell>

                <TableCell
                  className="MuiTableCell-root-trail"
                  style={{ textAlign: 'center' }}
                >
                  Amount
                </TableCell>

              </TableRow>
            </TableHead>

            <TableBody className="MuiTableBody-root-trail">
              {this.state.sections?.map((row, rowIndex) => (
                    <TableRow
                      key={rowIndex}
                      style={{
                        backgroundColor: (row.name === 'Operating Income' || row.name === 'Cost of Sales' ||  row.name === 'Taxes' ||
                          row.name === 'Operating Expenses' || row.name === 'Other Income')
                          ? 'rgb(245, 245, 245)' : 'transparent',

                        cursor:
                          row?.ledgerId != null &&
                          row.shiftDebit === '0.00' &&
                          row.shiftCredit === '0.00' &&
                          row.name !== 'Net Income' &&
                          row.name !== 'Cost of Sales' &&
                          row.name !== 'Other Income' &&
                          row.name !== 'Taxes' &&
                          row.name !== 'Net Operating Income' &&
                          row.name !== 'Operating Income' &&
                          row.name !== 'Operating Expenses' &&
                          row.name !== 'Gross Profit' &&
                          row.blankLine !== 'header' &&
                          !row.name.includes('Total') &&
                          this.props.isEdit
                            ? 'grab'
                            : 'default',
                      }}
                    >

                      {row?.ledgerId != null &&
                      row.shiftDebit === '0.00' &&
                      row.shiftCredit === '0.00' &&
                      row.name !== 'Net Income' &&
                      row.name !== 'Cost of Sales' &&
                      row.name !== 'Other Income' &&
                      row.name !== 'Taxes' &&
                      row.name !== 'Net Operating Income' &&
                      row.name !== 'Operating Income' &&
                      row.name !== 'Operating Expenses' &&
                      row.blankLine !== 'header' &&
                      row.name !== 'Gross Profit' &&
                      !row.name.includes('Total') &&
                      this.props.isEdit  ? (
                        <TableCell className="MuiTableCell-root-trail">
                          <MenuIcon style={{ cursor: 'grab', marginRight: 8 }} />
                        </TableCell>
                      ) : (
                        <TableCell className="MuiTableCell-root-trail">
                          {row?.ledgerId == null && this.props.isEdit ? (
                            <Tooltip title={'Edit Entry'}>
                              <IconButton
                                onClick={() => {
                                  this.handleEditClick(rowIndex, row.name);
                                }}
                              >
                                <EditIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          ) : (
                            <DragHandleIcon
                              style={{
                                cursor: 'grab',
                                marginRight: 8,
                                visibility: 'hidden',
                              }}
                            />
                          )}
                        </TableCell>
                      )}


                      <TableCell
                        className="MuiTableCell-root-trail"
                        style={{
                          // height: '75px',
                          fontWeight:
                            (Array.isArray(row?.totalIds) && row.totalIds.length > 0) ||
                            row?.name === 'Net Income' ||  row?.name === 'Net Operating Income' || row?.name === 'Operating Expenses' ||
                            row?.name === 'Other Income' ||   row?.name === 'Taxes' ||  row?.name === 'Operating Income' ||  row?.name === 'Cost of Sales' ||
                            row?.name.includes('Total') || row?.name === 'Gross Profit'
                              ? 'bold'
                              : 'normal',
                        }}
                      >

                        {row.name}

                      </TableCell>

                      <TableCell
                        style={{
                          fontWeight:
                            (Array.isArray(row?.totalIds) && row.totalIds.length > 0) ||
                            row?.name === 'Net Income' ||  row?.name === 'Net Operating Income' || row?.name === 'Operating Expenses' ||
                            row?.name === 'Other Income' ||   row?.name === 'Taxes' ||  row?.name === 'Operating Income' ||  row?.name === 'Cost of Sales' ||
                            row?.name.includes('Total') || row?.name === 'Gross Profit'
                              ? 'bold'
                              : 'normal',
                          textAlign: 'right',
                          paddingRight: '50px',
                          width: '15%',
                        }}
                        className="MuiTableCell-root-trail"
                      >


                        {row.name === 'Net Operating Income' || row.debit !== '0.00' ? (
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'flex-start',
                              alignItems: 'center',
                            }}
                          >
                            <span style={{ flexShrink: 0 }}>$</span>
                            <span
                              style={{
                                marginLeft: '55px',
                                minWidth: '80px',
                                textAlign: 'right',
                              }}
                            >
                              {this.formatBalance(row.debit)}
                            </span>
                          </div>
                        ) : (
                          ''
                        )}

                      </TableCell>


                    </TableRow>


              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </React.Fragment>
    );
  }
}

export default IncomeStatementTable;
